import { useCallback } from 'react';
export const useOnMouseDown = ({ option, onSelect, isSelected, mode, setOptionsAreOpen, setValue, setFocused, }) => {
    const onMouseDown = useCallback((e) => {
        e.preventDefault();
        if (isSelected)
            return;
        if (onSelect)
            onSelect(option);
        if (mode === 'single' && setValue) {
            setValue(option.label);
            setOptionsAreOpen(false);
            // @ts-ignore
            document?.activeElement?.blur();
            setFocused(false);
        }
    }, [option, onSelect, isSelected, mode, setOptionsAreOpen]);
    return onMouseDown;
};
